import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Link } from 'react-router-dom';
import formatDateToBR from '../../../utils/formatDateToBR';
import { newsText } from '../helpers/newsSeo';
import NewsImage from './NewsImage';


function NewsHomeColumnReutersComponent({
    dataNewsReuters,
    isVisible,
    countNewsView,
}) {
    useEffect(() => {
        if (isVisible) {
            dataNewsReuters.forEach((news) => {
                countNewsView({
                    newsId: news.id,
                    timestamp: Date.now(),
                });
            });
        }
    }, [isVisible, countNewsView, dataNewsReuters]);

    if (!dataNewsReuters || dataNewsReuters.length === 0) {
        return (
            <div className="tw-container tw-mx-auto tw-py-8 tw-space-y-8">
                <div className="tw-border-t tw-border-b tw-border-gray-700">
                    <p className="tw-my-4">Matérias Reuters</p>
                </div>
                <p className="tw-text-sm tw-text-gray-500">Nenhuma notícia disponível no momento.</p>
            </div>
        );
    }

    return (
        <div className="tw-container tw-mx-auto">
            <div className="tw-block tw-text-left tw-w-full">
                {dataNewsReuters.map((news, index) => {
                    const link = `/noticias/${news.slug}`;
                    const isLastItem = index === dataNewsReuters.length - 1;

                    return (
                        <div key={news.id} className="box">
                            <Link
                                to={link}
                                className={`tw-flex md:tw-px-0 tw-items-start tw-flex-col ${
                                    isLastItem ? '' : 'tw-pb-2'
                                }`}
                                title={`Saiba mais sobre ${news.title}`}
                            >
                                <p className="alternativeFontSize tw-m-0 tw-text-gray-500 data-publicacao">
                                    {formatDateToBR(news.date)}
                                </p>
                                <h3 className="tw-text-xl tw-font-bold tw-text-start tw-text-gray-800 tw-mt-2 limitText2">
                                    {newsText(news.title)}
                                </h3>
                                <figure className="tw-w-full tw-my-4 tw-overflow-hidden">
                                    <NewsImage news={news} sizes="(min-width: 1280px) 280px, (min-width: 768px) 30vw, calc(100vw - 40px)" />
                                </figure>
                                <p className="tw-mb-0 limitText2">
                                    {/* <TruncatedContent content={news.content} /> */}
                                    {newsText(news.content)}
                                </p>
                            </Link>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

NewsHomeColumnReutersComponent.propTypes = exact({
    dataNewsReuters: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            date: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            imageNew: PropTypes.string,
        }),
    ).isRequired,
    breakpointReducer: PropTypes.shape({
        serverBreakPoints: PropTypes.shape({
            isExtraLarge: PropTypes.bool,
            isLarge: PropTypes.bool,
            isMedium: PropTypes.bool,
        }).isRequired,
    }).isRequired,
    isVisible: PropTypes.bool,
    countNewsView: PropTypes.func.isRequired,
});

export default NewsHomeColumnReutersComponent;
